import React, { useState, useEffect } from "react";
import "../../styles/MenuItems.css";
import "../../styles/Styles.css";

function Pastas_PotatoCakes_Dumplings_Burgers() {

    const [pastas, setPastas] = useState([]);
    const [potatoCakes, setPotatoCakes] = useState([]);
    const [dumplings, setDumplings] = useState([]);
    const [burgers, setBurgers] = useState([]);

    useEffect(() => {
        fetch('https://strapi.restauracjasamiswoi.pl/api/categories?populate=menu_items&pagination[pageSize]=30')
        .then(response => response.json())
        .then((data) => {
            const categoryPastas = data.data.find(item => item.name === 'MAKARONY');
            const categoryPotatoCakes = data.data.find(item => item.name === 'PLACKI ZIEMNIACZANE');
            const categoryDumplings = data.data.find(item => item.name === 'PIEROGI');
            const categoryBurgers = data.data.find(item => item.name === 'BURGERY');

            if (categoryPastas) {
                setPastas(categoryPastas.menu_items);
            }

            if (categoryPotatoCakes) {
                setPotatoCakes(categoryPotatoCakes.menu_items);
            }

            if (categoryDumplings) {
                setDumplings(categoryDumplings.menu_items);
            }

            if (categoryBurgers) {
                setBurgers(categoryBurgers.menu_items);
            }
            
        })

    }, []);

    return (

        <div className="container-fluid section-pastas-potato-cakes-dumplings-burgers-background">
            <div className="container">
                <div className="menu-item-title-section-shrink d-flex justify-content-between">
                    <p className="menu-item-title-font m-0 fs-1 fw-bold pt-5">MAKARONY</p>
                </div>
                <hr/>
                {pastas.map((pasta) => (
                <div key={pasta.id} className="container">
                    <div className="dish-name-container d-flex justify-content-between">
                        <p className="menu-item-title-font fs-5 m-0">{pasta.name}</p>
                        <p className="fs-5 no-wrap m-0">{pasta.price}zł</p>
                    </div>
                    <p className="ingridients-container fs-6 m-0 fw-lighter">{pasta.ingredients}</p>
                    <div className="mb-3 mt-3 divide-line"/>
                </div>
                ))}
            <div className="menu-item-title-section d-flex justify-content-between align-items-end">
            <p className="menu-item-title-font fs-1 m-0 fw-bold pt-5">PLACKI ZIEMNIACZANE</p>
            <p className="fs-5 m-1 no-wrap fw-light">3 sztuki</p>
            </div>
            <hr/>
            {potatoCakes.map((potatoCake) => (
                <div key={potatoCake.id} className="container">
                    <div className="dish-name-container d-flex justify-content-between">
                        <p className="menu-item-title-font fs-5 m-0">{potatoCake.name}</p>
                        <p className="fs-5 m-0">{potatoCake.price}zł</p>
                    </div>
                    <p className="ingridients-container fs-6 m-0 fw-lighter">{potatoCake.ingredients}</p>
                    <div className="mb-3 mt-3 divide-line"/>
                </div>
            ))}
            <div className="menu-item-title-section d-flex justify-content-between align-items-end">
            <p className="menu-item-title-font fs-1 m-0 fw-bold pt-5">PIEROGI</p>
            <p className="fs-5 m-1 fw-light">8 sztuk</p>
            </div>
            <hr/>
            {dumplings.map((dumpling) => (
                <div key={dumpling.id} className="container">
                    <div className="dish-name-container d-flex justify-content-between">
                        <p className="menu-item-title-font fs-5 m-0">{dumpling.name}</p>
                        <p className="fs-5 m-0">{dumpling.price}zł</p>
                    </div>
                    <p className="ingridients-container fs-6 m-0 fw-lighter">{dumpling.ingredients}</p>
                    <div className="mb-3 mt-3 divide-line"/>
                </div>
            ))}
            <div className="menu-item-title-section-shrink d-flex justify-content-between">
            <p className="menu-item-title-font fs-1 m-0 fw-bold pt-5">BURGERY</p>
            <p className="fs-5 m-1 fw-light">z frytkami belgijskimi</p>
            </div>
            <hr/>
            {burgers.map((burger) => (
                <div key={burger.id} className="container">
                    <div className="dish-name-container d-flex justify-content-between">
                        <p className="menu-item-title-font fs-5 m-0">{burger.name}</p>
                        <p className="fs-5 m-0">{burger.price}zł</p>
                    </div>
                    <p className="ingridients-container fs-6 m-0 fw-lighter">{burger.ingredients}</p>
                    <div className="mb-3 mt-3 divide-line"/>
                </div>
            ))}
            </div>
        </div>

    )

}

export default Pastas_PotatoCakes_Dumplings_Burgers;